import UserStore from '@/feature/ucenter/user/store/UserStore'
import AppStore from '@home/stores/AppStore'
import BackendStore from '@home/stores/BackendStore'
import RoleStore from '@/feature/ucenter/user/store/RoleStore'
import SwitchCompanyStore from '@/feature/ucenter/user/store/SwitchCompanyStore'
import ApiStore from '@/feature/ucenter/api/store/ApiStore'
import TableLayoutStore from '@home/router/backend/LayoutDemo/stores/TableLayoutStore'
import MenuTableLayoutStore from '@home/router/backend/LayoutDemo/stores/MenuTableLayoutStore'
import ShoppingCartStore from "@home/stores/ShoppingCartStore";
import ShoppingIndexStore from "@home/stores/ShoppingIndexStore";
import PayStore from "@home/stores/PayStore";
import ItemsStore from "@home/stores/ItemsStore";
import DetailsStore from "@home/stores/DetailsStore";
import MerchantMallStore from "@home/stores/MerchantMallStore";
import MerchantRegStore from "@home/stores/MerchantRegStore";
import OrderStore from "@home/stores/OrderStore";
import CategoryStore from "@home/stores/CategoryStore";

 const Store = {
  userStore: new UserStore(),
  roleStore: new RoleStore(),
  appStore: new AppStore(),
  backendStore: new BackendStore(),
  switchCompanyStore: new SwitchCompanyStore(),
  apiStore: new ApiStore(),
  tableLayoutStore : new TableLayoutStore(),
  menuTableLayoutStore:new MenuTableLayoutStore(),
  shoppingCartStore:new ShoppingCartStore(),
  shoppingIndexStore:new ShoppingIndexStore(),
  payStore:new PayStore(),
  itemsStore:new ItemsStore(),
  detailsStore:new DetailsStore(),
  merchantMallStore:new MerchantMallStore(),
  merchantRegStore:new MerchantRegStore(),
  orderStore:new OrderStore(),
  categoryStore:new CategoryStore()
}

export default Store
